import { localesDomus_de, localesHg_de } from '@smg-real-estate/domus';

import localesApp from './locales/de-CH.json';
import localesTheme from './locales/homegate-de-CH.json';

export default {
  ...localesDomus_de,
  ...localesHg_de,
  ...localesTheme,
  ...localesApp,
};
